module.exports = __webpack_public_path__ + "media/images/icon__search--rb-gray@2x-e020df639e6bdf3839302e115de81127.png";